export default __webpack_public_path__ + "static/media/ic_image.0aa5b62f.svg";